import { Theme } from '../../../css/baseStyles';

type StyleProps = {
  theme: Theme;
  deviceHeight: number;
};

export const getHorizontalPaginationStyles = ({ theme, deviceHeight }: StyleProps) => {
  return `
  <style id="RWHorizontalPaginationStyles">
      .bottom-margin {
        display: none;
      }
      .disable-scroll-due-to-reduce-animations .rw-chunk-container {
        overflow: hidden!important;
      }
      .rw-header-container {
        display: none;
      }
      #bottom-divider {
        display: none !important;
      }
      .end-of-reading-container {
        display: none !important;
      }
      .rw-chunk-container {
        display: none;
      }
      .disable-scroll .rw-chunk-container {
        pointer-events: none;
      }
      .left-side-border {
        display: block;
        top: 0;
        left: 0;
        position: absolute;
        height: 100%;
        mask-image: linear-gradient(to left, transparent, black 25px);
        -webkit-mask-image: linear-gradient(to left, transparent, black 25px);
      }
      .right-side-border {
        right: 0;
        display: block;
        top: 0;
        right: 0;
        position: absolute;
        height: 100%;
        mask-image: linear-gradient(to right, transparent, black 25px);
        -webkit-mask-image: linear-gradient(to right, transparent, black 25px);
      }
  </style>
  `;
};
